import React from 'react';

import MomentUtils from '@date-io/moment';
import { Field, FieldConfig } from 'formik';
import { DatePicker, DatePickerProps, MuiPickersUtilsProvider, TimePicker } from 'material-ui-pickers';
import { TimePickerModalProps } from 'material-ui-pickers/TimePicker/TimePickerModal';
import moment, { Moment } from 'moment';

export interface FieldDateTimePickerProps extends FieldConfig {
  datePickerProps?: Partial<DatePickerProps>;
  timePickerProps?: Partial<TimePickerModalProps>;
  disabled?: boolean;
}

export const FieldDateTimePicker: React.FC<FieldDateTimePickerProps> = ({
  datePickerProps,
  timePickerProps,
  disabled,
  ...rest
}) => (
  <Field {...rest}>
    {({ field, form }: any) => {
      const errorText = form.errors[field.name];
      return (
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <DatePicker
            data-lh-id={`date-picker-${field.name}`}
            format="L"
            animateYearScrolling={false}
            {...field}
            {...datePickerProps}
            onChange={(date: Moment) =>
              form.setFieldValue(
                field.name,
                moment(`${date.format('YYYY-MM-DD')} ${moment(field.value).format('HH:mm')}`),
              )
            }
            // https://github.com/react-dnd/react-dnd/issues/701
            onDrop={(e) => e.preventDefault()}
            disabled={disabled}
          />
          <TimePicker
            data-lh-id={`time-picker-${field.name}`}
            autoComplete="nope"
            {...field}
            {...timePickerProps}
            error={!disabled && !!errorText}
            helperText={!disabled && errorText}
            onChange={(date: Moment) =>
              form.setFieldValue(
                field.name,
                moment(`${moment(field.value).format('YYYY-MM-DD')} ${date.format('HH:mm')}`),
              )
            }
            // https://github.com/react-dnd/react-dnd/issues/701
            onDrop={(e) => e.preventDefault()}
            disabled={disabled}
          />
        </MuiPickersUtilsProvider>
      );
    }}
  </Field>
);
